import React from "react";
import "../../Styles/certified/mithra.css";

export default function MithraConsulting() {
  return (
    <>
      <div className="mithra-certified-details-section">
        <div className="mithra-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="mithra-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="mithra-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="mithra-certified-badge"
            />
            <div className="mithra-certified-company-names">
              <a href="https://www.mithra.consulting" target="_blank" rel="noopener noreferrer">
                <img src="/assets/mithra/mithra.png" alt="Mithra Consulting Logo" className="mithra-certified-company-logo" />
              </a>
              <h1 className="mithra-certified-full-name">
                Mithra Consulting
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="mithra-certified-details-right">
            <img
              src="/assets/mithra/IMG_3950.jpg"
              alt="Mithra Consulting Office"
              className="mithra-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="mithra-certified-description">
          <h2>
            Why Mithra Consulting is an Outstanding Workplaces
          </h2>
          <p>
            Mithra Consulting is a technology services organization delivering Cyber Security, Cloud, and IT Solutions to businesses across industries. 
            The organization supports clients in securing applications, infrastructure, and cloud environments while ensuring stable and efficient IT operations. 
            Mithra Consulting provides services such as security assessments and testing, cloud security and architecture support, and end-to-end IT solutions designed to improve resilience, reliability, and trust in digital systems.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="mithra-certified-info-cards">
          <div className="mithra-certified-info-card">
            <div className="mithra-certified-info-title">COMPANY SIZE</div>
            <div className="mithra-certified-info-value">25 Employees</div>
          </div>
          <div className="mithra-certified-info-card">
            <div className="mithra-certified-info-title">INDUSTRY</div>
            <div className="mithra-certified-info-value">Information Technology</div>
          </div>
          <div className="mithra-certified-info-card">
            <div className="mithra-certified-info-title">CONNECT</div>
            <div className="mithra-certified-info-icons">
              <span className="mithra-certified-icon-round">
                <a href="https://www.mithra.consulting" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="mithra-certified-icon-round">
                <a href="https://www.linkedin.com/in/sbharath1012" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              {/* <span className="mithra-certified-icon-round">
                <a href="https://www.facebook.com/mithraconsulting" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="mithra-certified-icon-round">
                <a href="https://www.instagram.com/mithraconsulting" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="mithra-certified-icon-round">
                <a href="https://x.com/mithraconsult" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span> */}
            </div>
          </div>
          <div className="mithra-certified-info-card">
            <div className="mithra-certified-info-title">LOCATION (HQ)</div>
            <div className="mithra-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="mithra-certified-recognition-section">
          <h2 className="mithra-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="mithra-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="mithra-certified-recognition-image"
            />
          </div>
          <div className="mithra-certified-recognition-label">
            Outstanding Workplaces - Platinum Certified
          </div>
        </div>
        {/* Life at Mithra Consulting Section */}
        <div className="mithra-certified-life-section">
          <h2 className="mithra-certified-life-title">
            Life at Mithra Consulting
          </h2>
          <div className="mithra-certified-life-gallery">
            <div className="mithra-certified-life-col">
              <img src="/assets/mithra/2.jpeg" alt="Office 2" className="mithra-certified-life-img" />
              <img src="/assets/mithra/IMG_3948.jpg" alt="Team" className="mithra-certified-life-img" />
            </div>
            <div className="mithra-certified-life-col mithra-certified-life-center">
              <img src="/assets/mithra/1.jpeg" alt="Main Office" className="mithra-certified-life-img mithra-certified-life-img-large" />
            </div>
            <div className="mithra-certified-life-col">
              <img src="/assets/mithra/IMG_4675.jpg" alt="Office 4" className="mithra-certified-life-img" />
              <img src="/assets/mithra/IMG_3950.jpg" alt="Meeting" className="mithra-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}